import {AnyAction} from 'redux';
import Types from '../../../actions/Types';

import Help from '../../../../domain/entities/writer/Help';

export default function reducer(
  state: {[key: number]: Help} = {},
  action: AnyAction,
): {[key: number]: Help} {
  switch (action.type) {
    case Types.IndexWriterHelpsSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: Help}, record: Help) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowWriterHelpSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
